import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
	CreateDiagnosticQuestion,
	DiagnosticQuestion,
	PublishDiagnosticQuestions,
	UpdateDiagnosticQuestion,
} from '../models/diagnosis.model';

@Injectable({
	providedIn: 'root'
})
export class DiagnosticQuestionsService {

	constructor(
		private http: HttpClient,
	) { }

	public createQuestion(question: CreateDiagnosticQuestion): Observable<string> {
		return this.http.post<string>(`${environment.SERVICES.GAME}v2/diagnostic-questions`, question);
	}

	public updateQuestion(questionId: string, question: UpdateDiagnosticQuestion): Observable<void> {
		return this.http.put<void>(`${environment.SERVICES.GAME}v2/diagnostic-questions/${questionId}`, question);
	}

	public getAllQuestions(): Observable<DiagnosticQuestion[]> {
		return this.http.get<DiagnosticQuestion[]>(`${environment.SERVICES.GAME}v2/diagnostic-questions`);
	}

	public getQuestion(questionId: string): Observable<DiagnosticQuestion> {
		return this.http.get<DiagnosticQuestion>(`${environment.SERVICES.GAME}v2/diagnostic-questions/${questionId}`);
	}

	public deleteQuestion(questionId: string): Observable<void> {
		return this.http.delete<void>(`${environment.SERVICES.GAME}v2/diagnostic-questions/${questionId}`);
	}

	public publishQuestions(payload: PublishDiagnosticQuestions): Observable<void> {
		return this.http.post<void>(`${environment.SERVICES.GAME}v2/diagnostic-questions/publish`, payload);
	}
}
